export const ADD_FLIGHT = 'flightBooking/addFlight';
export const DELETE_FLIGHT = 'flightBooking/deleteFlight';
